module.exports = __webpack_public_path__ + "public/images/Illustration_Flyer_200x200-Color.17b716f6761e09673c6c6c78555a10fb.png";